module.exports = __webpack_public_path__ + "img/checklist-yellow.a7841a88.svg";